// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Blog_wrapper__349UP","blog-body":"Blog_blog-body__3QhUD"};